import axios from "axios";
import { handleUnauthorizedResponse } from "../../apiHelper";
import AxiosInstance1 from "../AxiosInstance/AxiosInstance1";
const GetInitiativeActioItems = async (IdeaId, userID) => {
  console.log("GetInitiativeActioItems", IdeaId, userID);
  const accessToken = sessionStorage.getItem("access_token");

  try {
    const response = await AxiosInstance1.get(
      `/api/InitiativeDetail/GetInitiativeActioItems`,
      {
        params: { IdeaId, userID }
      }
    );
    handleUnauthorizedResponse(response);
    return response.data;
  } catch (error) {
    console.error("Error fetching initiative detail:", error);
    throw new Error("Failed to fetch initiative detail");
  }
};

export default GetInitiativeActioItems;
